import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { RecentOrderTileBannerMessage } from '@shared/constants/homepage-recent-order.enum';
import { RecentOrderTileViewModel } from '@order/models/recent-order-tile-view-model';
import { DisplayType } from '@shared/constants/order-status-title.enum';
import { OrderStatus } from '@usf/ngrx-order';

@Component({
  selector: 'app-recent-order-tile',
  templateUrl: './recent-order-tile.component.html',
  styleUrls: ['./recent-order-tile.component.scss'],
})
export class RecentOrderTileComponent {
  DisplayType = DisplayType;
  @Input() recentOrderViewModel: RecentOrderTileViewModel;
  @Input() platformService: PlatformService;
  @Output()
  handleRecentOrderButtonClick: EventEmitter<any> = new EventEmitter();
  @Output() viewMyOrdersClick: EventEmitter<any> = new EventEmitter();
  @Output() createNewOrderClick: EventEmitter<any> = new EventEmitter();

  recentOrderTileBannerMessage = RecentOrderTileBannerMessage;

  constructor(readonly panAppState: PanAppState) {}

  recentOrderButtonClicked() {
    this.handleRecentOrderButtonClick.emit();
  }
  viewMyOrdersClicked() {
    this.viewMyOrdersClick.emit();
  }
  createNewOrderClicked() {
    this.createNewOrderClick.emit();
  }

  determineOrderStatusClass() {
    if (
      this.recentOrderViewModel?.orderStatusDisplayType ===
        DisplayType.NO_ORDER ||
      this.recentOrderViewModel?.recentOrder?.orderHeader?.orderStatus ===
        OrderStatus.IN_PROGRESS
    ) {
      return null;
    }
    // Determine if we are on a direct/vendor shipped order with a displayOrderStatus
    const useNewDisplayOrderStatus =
      this.recentOrderViewModel?.recentOrder?.orderHeader?.orderType === 'VS' &&
      !!this.recentOrderViewModel?.recentOrder?.orderHeader?.displayOrderStatus
        ?.length;

    if (useNewDisplayOrderStatus) {
      return this.recentOrderViewModel?.orderStatusDisplayType ===
        DisplayType.OUT_FOR_DELIVERY ||
        this.recentOrderViewModel?.orderStatusDisplayType ===
          DisplayType.QUANTITIES_UPDATED ||
        this.recentOrderViewModel?.orderStatusDisplayType ===
          DisplayType.ATTEMPTED_DELIVERY ||
        this.recentOrderViewModel?.orderStatusDisplayType ===
          DisplayType.DELIVERED
        ? 'green-text'
        : 'red-text';
    } else {
      return this.recentOrderViewModel?.recentOrder?.orderHeader
        ?.orderStatus === OrderStatus.SUBMITTED ||
        this.recentOrderViewModel?.recentOrder?.orderHeader?.orderStatus ===
          OrderStatus.SUBMITTED_CREDIT_HOLD
        ? 'green-text'
        : 'red-text';
    }
  }
}
